var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-center text-center"},[_c('div',[_c('button',{staticClass:"h-10 px-2 text-xs font-semibold text-white bg-indigo-700 rounded shadow-2xl sm:px-4 lg:px-6 xl:px-8 sm:h-16 sm:text-base md:text-lg lg:text-xl xl:text-2xl hover:cursor-pointer hover:bg-indigo-600",on:{"click":_vm.click}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }